import { defineStore } from "pinia";

import CalculatorPresetsApi from "@/services/api/calculatorPresetsApi";
import OrderCalculationSettingsApi from "@/services/api/orderCalculationSettingsApi";

import { useNotificationStore } from "@/stores/notificationStore";

import { getCompanyId } from "@/utils/userUtils";

export const useOrderCalculationSettingsStore = defineStore(
  "orderCalculationSettings",
  {
    state: () => ({
      setting: null,
      availablePresets: [],
      companyId: getCompanyId(),
      dataIsLoading: false,
      isSubmitting: false,
    }),

    actions: {
      async fetchSetting({ includePresets = true } = {}) {
        this.dataIsLoading = true;
        try {
          const presetsRequest = includePresets
            ? CalculatorPresetsApi.index(this.companyId, {
                q: { enabled: true },
                limit: 100,
              })
            : null;
          const [settingResponse, presetsResponse] = await Promise.all([
            OrderCalculationSettingsApi.show(this.companyId),
            presetsRequest,
          ]);
          this.setting = settingResponse.data.result;
          if (presetsResponse) {
            this.availablePresets = presetsResponse.data.result || [];
          }
          return this.setting;
        } finally {
          this.dataIsLoading = false;
        }
      },

      async updateSetting(defaultCalculatorPresetId) {
        this.isSubmitting = true;
        try {
          const response = await OrderCalculationSettingsApi.update(
            this.companyId,
            { default_calculator_preset_id: defaultCalculatorPresetId }
          );
          this.setting = response.data.result;
          useNotificationStore().showSuccess(
            "Калькулятор для заказов сохранён"
          );
          return this.setting;
        } finally {
          this.isSubmitting = false;
        }
      },
    },
  }
);
